module.exports = __webpack_public_path__ + "img/stat-icon-2.87358ce7.png";